(() => {
  if (window.__melR57ChromeReady) return;
  window.__melR57ChromeReady = true;

  const setFooterAccordions = (scope = document) => {
    const roots = [];
    if (scope instanceof Element && scope.matches('.mel-r57-footer-root')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('.mel-r57-footer-root'));
    const desktop = window.matchMedia('(min-width: 761px)');

    roots.forEach((root) => {
      if (root.dataset.r57ChromeReady === 'true') return;
      root.dataset.r57ChromeReady = 'true';
      const panels = [...root.querySelectorAll('[data-r57-footer-accordion]')];
      const setMode = () => panels.forEach((panel) => { panel.open = desktop.matches; });
      setMode();
      desktop.addEventListener('change', setMode);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setFooterAccordions(), { once: true });
  } else {
    setFooterAccordions();
  }
  document.addEventListener('shopify:section:load', (event) => setFooterAccordions(event.target));
})();

(() => {
  if (window.__melR57CartBadgeReady) return;
  window.__melR57CartBadgeReady = true;
  const update = count => {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('[data-mel-cart-count]').forEach(badge => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  };
  window.theme?.pubsub?.subscribe?.(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, event => {
    update(event.cart?.item_count);
  });
})();

(() => {
  if (window.__melR57MenuMineralsReady) return;
  window.__melR57MenuMineralsReady = true;
  const initMenuMinerals = (scope) => {
    const thumbs = [...scope.querySelectorAll('.mel-material-menu-thumb')];
    const lifetime = new AbortController();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        target.dataset.r57GemVisible = String(isIntersecting);
      });
    }, { threshold: 0.3 });
    const owned = [];
    thumbs.forEach((thumb, index) => {
      if (thumb.dataset.r57GemReady) return;
      const img = thumb.querySelector('img');
      if (!img) return;
      thumb.dataset.r57GemReady = 'loading';
      const handle = thumb.closest('a')?.getAttribute('href')?.split('/').pop() || '';
      const kind = /moonstone|labradorite|opal|aquamarine|fluorite|apatite|mood/.test(handle) ? 'cool' :
        /tigers-eye|citrine|amber|gold|copper/.test(handle) ? 'warm' :
        /amethyst|ruby|garnet|sapphire|diamond|zircon/.test(handle) ? 'faceted' : 'silk';
      thumb.dataset.r57GemLight = kind;
      thumb.style.setProperty('--r57-gem-delay', `${-(index * 0.379) % 4}s`);
      thumb.style.setProperty('--r57-gem-duration', `${3.4 + (index % 5) * 0.27}s`);
      const decoded = () => {
        const src = img.currentSrc || img.src;
        if (!img.naturalWidth || !src) return;
        thumb.style.setProperty('--r57-gem-image', `url(${JSON.stringify(src)})`);
        thumb.dataset.r57GemReady = 'true';
      };
      img.addEventListener('load', decoded, { signal:lifetime.signal });
      if (img.complete) decoded();
      observer.observe(thumb);
      owned.push(thumb);
    });
    if (!owned.length) { observer.disconnect(); return; }
    document.addEventListener('shopify:section:unload', (event) => {
      owned.forEach(thumb => { if(event.target.contains(thumb)) observer.unobserve(thumb); });
      if (owned.every(thumb => !thumb.isConnected || event.target.contains(thumb))) lifetime.abort();
    }, { signal:lifetime.signal });
  };


  const init = (scope = document) => initMenuMinerals(scope);
  document.addEventListener('visibilitychange', () => {
    document.documentElement.dataset.r57PageHidden = String(document.visibilityState !== 'visible');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(() => {
  if (window.__melWishlistReady) return;
  window.__melWishlistReady = true;
  const key = 'mel-wishlist-v1';
  const validHandle = handle => /^[a-z0-9][a-z0-9-]{0,99}$/.test(handle || '');
  const safeItem = item => {
    if (!validHandle(item?.handle)) return null;
    const rawImage = String(item.image || '');
    const image = rawImage.startsWith('//') ? `https:${rawImage}` : rawImage;
    return {
      handle: item.handle,
      title: String(item.title || item.handle.replaceAll('-', ' ')).slice(0, 180),
      url: `/products/${item.handle}`,
      image: /^https:\/\//.test(image) ? image : ''
    };
  };
  const read = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(parsed) ? parsed.map(safeItem).filter(Boolean).slice(0, 100) : [];
    } catch { return []; }
  };
  let items = read();
  try {
    Object.keys(localStorage).filter(oldKey => oldKey.startsWith('mel-wishlist-') && oldKey !== key).forEach(oldKey => {
      const handle = oldKey.slice('mel-wishlist-'.length);
      if (validHandle(handle) && handle !== 'global' && localStorage.getItem(oldKey) === 'true' && !items.some(item => item.handle === handle)) {
        items.push(safeItem({ handle }));
      }
      localStorage.removeItem(oldKey);
    });
    localStorage.setItem(key, JSON.stringify(items));
  } catch { /* Storage can be unavailable in private contexts. */ }

  const getDialog = () => document.getElementById('MelWishlistDialog');
  const render = () => {
    const dialog = getDialog();
    const list = dialog?.querySelector('[data-mel-wishlist-list]');
    if (list) {
      list.replaceChildren();
      items.forEach(item => {
        const row = document.createElement('li');
        const link = document.createElement('a');
        link.href = item.url;
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = '';
          image.loading = 'lazy';
          link.append(image);
        }
        const title = document.createElement('span');
        title.textContent = item.title;
        link.append(title);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = '×';
        remove.setAttribute('aria-label', `${dialog.dataset.melWishlistRemoveLabel || 'Remove'}: ${item.title}`);
        remove.dataset.melWishlistRemove = item.handle;
        row.append(link, remove);
        list.append(row);
      });
    }
    const empty = dialog?.querySelector('[data-mel-wishlist-empty]');
    if (empty) empty.hidden = items.length > 0;
    document.querySelectorAll('[data-mel-wishlist-count]').forEach(badge => {
      badge.textContent = String(items.length);
      badge.hidden = !items.length;
    });
    document.querySelectorAll('[data-mel-wishlist]').forEach(button => {
      const handle = button.closest('[data-product-handle]')?.dataset.productHandle;
      if (!validHandle(handle) || handle === 'global') return;
      const selected = items.some(item => item.handle === handle);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', `${selected ? dialog?.dataset.melWishlistRemoveLabel : dialog?.dataset.melWishlistSaveLabel}: ${button.closest('[data-wishlist-title]')?.dataset.wishlistTitle || handle.replaceAll('-', ' ')}`);
    });
  };
  const persist = () => {
    try { localStorage.setItem(key, JSON.stringify(items)); } catch { /* The current page remains usable. */ }
    render();
  };
  const itemFor = button => {
    const root = button.closest('[data-product-handle]');
    const handle = root?.dataset.productHandle;
    if (!validHandle(handle) || handle === 'global' || !location.pathname.startsWith('/products/')) return null;
    return safeItem({
      handle,
      title: root.dataset.wishlistTitle || document.querySelector('main h1')?.textContent?.trim(),
      image: root.dataset.wishlistImage || root.querySelector('.mel-gallery__stage img, .mel-gallery__track img')?.currentSrc || document.querySelector('meta[property="og:image"]')?.content,
      url: root.dataset.wishlistUrl
    });
  };
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-mel-wishlist-open]');
    const dialog = getDialog();
    if (open && dialog) {
      render();
      dialog.showModal();
      dialog.querySelector('[data-mel-wishlist-close]')?.focus();
      return;
    }
    if (event.target.closest('[data-mel-wishlist-close]')) {
      dialog?.close();
      document.querySelector('[data-mel-wishlist-open]')?.focus();
      return;
    }
    const remove = event.target.closest('[data-mel-wishlist-remove]');
    if (remove) {
      items = items.filter(item => item.handle !== remove.dataset.melWishlistRemove);
      persist();
      dialog?.querySelector('[data-mel-wishlist-close]')?.focus();
      return;
    }
    const button = event.target.closest('[data-mel-wishlist]');
    if (!button) return;
    const item = itemFor(button);
    if (!item) return;
    items = items.some(saved => saved.handle === item.handle)
      ? items.filter(saved => saved.handle !== item.handle)
      : [item, ...items].slice(0, 100);
    persist();
  });
  document.addEventListener('shopify:section:load', render);
  window.addEventListener('storage', event => { if (event.key === key) { items = read(); render(); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true });
  else render();
})();

(() => {
  const init = () => {
    const chrome = document.querySelector('.mel-site-chrome--header');
    if (!chrome || chrome.dataset.r57StickyReady) return;
    chrome.dataset.r57StickyReady = 'true';
    let previousY = window.scrollY;
    let pending = false;
    const protectedInteraction = () =>
      chrome.contains(document.activeElement) ||
      !!chrome.querySelector('[data-mel-mega-menu]:not([hidden]), [data-mel-mobile-drawer]:not([hidden]), .mel-wishlist-dialog[open]');
    const update = () => {
      pending = false;
      const y = window.scrollY;
      const delta = y - previousY;
      if (y <= 120 || protectedInteraction()) chrome.classList.remove('is-r57-nav-hidden');
      else if (delta > 6) chrome.classList.add('is-r57-nav-hidden');
      else if (delta < -6) chrome.classList.remove('is-r57-nav-hidden');
      chrome.classList.toggle('is-r57-nav-raised', y > 120 && !chrome.classList.contains('is-r57-nav-hidden'));
      previousY = y;
    };
    window.addEventListener('scroll', () => {
      if (!pending) { pending = true; requestAnimationFrame(update); }
    }, { passive: true });
    chrome.addEventListener('focusin', () => chrome.classList.remove('is-r57-nav-hidden'));
    chrome.addEventListener('click', () => requestAnimationFrame(update));
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

// MSG029: hidden dropdowns have URLs in data attributes, never in src/srcset.
(() => {
  const init = (scope = document) => {
    const roots = scope.matches?.('.mel-site-chrome--header') ? [scope] : [...scope.querySelectorAll('.mel-site-chrome--header')];
    roots.forEach(root => {
      if (root.dataset.menuDeferredReady) return;
      root.dataset.menuDeferredReady = 'true';
      const hydrate = () => root.querySelectorAll('[data-mel-menu-src]').forEach(img => {
        if (img.closest('[hidden]') || img.closest('details:not([open])') || !img.getClientRects().length) return;
        img.src = img.dataset.melMenuSrc;
        img.removeAttribute('data-mel-menu-src');
      });
      const observer = new MutationObserver(hydrate);
      observer.observe(root, {subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-expanded', 'open']});
      root.addEventListener('click', () => requestAnimationFrame(hydrate));
      hydrate();
      document.addEventListener('shopify:section:unload', event => { if(event.target.contains(root)) observer.disconnect(); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
